import React, { ReactNode, useEffect, useState } from 'react';
import LinkService from '../../system/LinkService';
import useApiCall from '../../system/useApiCall';
import StandardTable from '../../common/Component/StandardTable';
import { GridColumns, GridRenderCellParams, GridRowModel, GridRowsProp } from '@mui/x-data-grid';
import WuEventDataDialog from './WuEventDataDialog';
import WuEventTO from '../TO/WuEventTO';
import { Checkbox } from '@mui/material';
import TableUtil from '../../system/TableUtil';

export default function WuEventPage() {
  const [editRow, setEditRow] = useState<number | null>(null);
  const [openDataDialog, setOpenDataDialog] = useState<boolean>(false);
  const [saveCount, setSaveCount] = useState<number>(0);
  const [wuEventList, setwuEventList] = useState<WuEventTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const apiCall = useApiCall();

  useEffect(() => {
    getWuEventAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveCount]);

  useEffect(() => {
    if (editRow === null && openDataDialog) {
      setOpenDataDialog(false);
    } else if (editRow !== null && !openDataDialog) {
      setOpenDataDialog(true);
    }
  }, [editRow, openDataDialog]);

  const getWuEventAll = () => {
    setIsLoading(true);
    apiCall.get(LinkService.wuEventAll()).then((data) => {
      if (data) {
        const list: WuEventTO[] = data;
        setwuEventList(list);
        setIsLoading(false);
      }
    });
  };

  const deleteWuEventData = (id: number) => {
    apiCall.delete(LinkService.wuEventDelete(id), 'Datensatz gelöscht.').then((data) => {
      getWuEventAll();
    });
  };

  const getEditData = () => {
    const wuEventData = wuEventList.find((item: WuEventTO) => item.id === editRow);
    return wuEventData;
  };

  const getEditDataById = (id: number) => {
    const wuEventData = wuEventList.find((item: WuEventTO) => item.id === id);
    return wuEventData;
  };

  const updateDataFromUpdateWithinTable = (data: GridRowModel) => {
    const index = wuEventList.findIndex((item: WuEventTO) => item.id === data.id);
    if (index >= 0) {
      wuEventList[index] = { ...data };
    }
  };

  const renderWuEventActive = (params: GridRenderCellParams<any, any, any>): ReactNode => {
    return (
      <Checkbox
        id='isActive'
        checked={params.value}
        onChange={(e) => {
          const wuEventData = getEditDataById(params.row.id);
          wuEventData!.active = e.target.checked;
          apiCall.post(LinkService.wuEventPost(), wuEventData, 'Speichern erfolgreich.').then((data) => {
            setSaveCount(saveCount + 1);
          });
        }}
      />
    );
  };

  const renderWuEventRegistrationFull = (params: GridRenderCellParams<any, any, any>): ReactNode => {
    return (
      <Checkbox
        id='isRegistrationFull'
        checked={params.value}
        onChange={(e) => {
          const wuEventData = getEditDataById(params.row.id);
          wuEventData!.registrationFull = e.target.checked;
          apiCall.post(LinkService.wuEventPost(), wuEventData, 'Speichern erfolgreich.').then((data) => {
            setSaveCount(saveCount + 1);
          });
        }}
      />
    );
  };

  const columns: GridColumns = [
    { field: 'id', headerName: 'ID', type: 'number', width: 40, editable: false },
    { field: 'name', headerName: 'Name', flex: 1, editable: true },
    { field: 'eventNumber', headerName: 'Event-Nummer', type: 'number', flex: 1, editable: true },
    { field: 'theme', headerName: 'Thema', flex: 1, editable: true },
    { field: 'hashtag', headerName: 'Hashtag*', flex: 1, editable: true },
    { field: 'description', headerName: 'Beschreibung', flex: 1, editable: true },
    { field: 'conditions', headerName: 'Bedingungen', flex: 1, editable: true },
    {
      field: 'eventDate',
      headerName: 'Event-Start',
      flex: 1,
      editable: false,
      valueFormatter: TableUtil.formatDateCell,
    },
    {
      field: 'registerStartDate',
      headerName: 'Anmeldestart',
      flex: 1,
      editable: false,
      valueFormatter: TableUtil.formatDateCell,
    },
    {
      field: 'registerStopDate',
      headerName: 'Anmeldestop',
      flex: 1,
      editable: false,
      valueFormatter: TableUtil.formatDateCell,
    },
    { field: 'maxParticipants', headerName: 'Max. Teilnehmeranzahl', type: 'number', flex: 1, editable: true },
    { field: 'maxRegistrations', headerName: 'Max. Registrierungen', type: 'number', flex: 1, editable: true },
    { field: 'active', headerName: 'Aktiv', flex: 1, editable: false, renderCell: renderWuEventActive },
    {
      field: 'registrationFull',
      headerName: 'Reg. voll',
      flex: 1,
      editable: false,
      renderCell: renderWuEventRegistrationFull,
    },
  ];

  const rows: GridRowsProp = [...wuEventList];

  return (
    <div>
      <WuEventDataDialog
        openDialog={openDataDialog}
        setEditRow={setEditRow}
        editData={editRow ? getEditData() : undefined}
        saveCount={saveCount}
        setSaveCount={setSaveCount}
      />
      <StandardTable
        saveURL={LinkService.wuEventPost()}
        editRowNumber={setEditRow}
        columns={columns}
        rows={rows}
        deleteFunction={deleteWuEventData}
        isLoading={isLoading}
        updateDataSource={updateDataFromUpdateWithinTable}
      />
    </div>
  );
}
